module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/click_buy.gif";